var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from "react";
import { defaultFormStateDefinition, FormStateContext } from "../context/form-state-context";
import { mapValues, pickBy } from "lodash";
export var useFormState = function (formName) {
  var context = React.useContext(FormStateContext);
  if (!context) {
    throw new Error('useFormState must be used within a FormStateProvider');
  }
  var patch = context.patchForm(formName);
  var formState = context.state[formName] || defaultFormStateDefinition;
  var canSubmit = function () {
    if (!formState.isValid) {
      return false;
    }
    if (formState.canSubmit) {
      return formState.canSubmit();
    }
    return true;
  };
  var mutationValue = React.useMemo(function () {
    var fields = mapValues(formState.fields, function (field) {
      return field.mutationValue;
    });
    var metadata = pickBy(mapValues(formState.fields, function (field) {
      return field.meta;
    }));
    return __assign(__assign({}, fields), {
      metadata: {
        fieldData: JSON.stringify(metadata)
      }
    });
  }, [formState.fields]);
  var value = React.useMemo(function () {
    return mapValues(formState.fields, function (field) {
      return field.value;
    });
  }, [formState.fields]);
  return __assign(__assign({}, formState), {
    canSubmit: canSubmit,
    patch: patch,
    mutationValue: mutationValue,
    value: value,
    reset: function () {
      return patch(defaultFormStateDefinition, 'replace');
    },
    resetFields: function () {
      return patch({
        fields: {}
      }, 'replace');
    },
    patchFields: function (fieldsPatch) {
      return patch({
        fields: fieldsPatch
      });
    }
  });
};